module.exports = __webpack_public_path__ + "lineup-bg.99bb5dc35bf10353e65c.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/soccer/lineup-bg.png
// module id = ../../../../../src/assets/images/soccer/lineup-bg.png
// module chunks = styles